import { render } from "./ImagesByFamilyComponent.vue?vue&type=template&id=5423e364&scoped=true"
import script from "./ImagesByFamilyComponent.vue?vue&type=script&lang=js"
export * from "./ImagesByFamilyComponent.vue?vue&type=script&lang=js"

import "./ImagesByFamilyComponent.vue?vue&type=style&index=0&id=5423e364&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5423e364"]])

export default __exports__